import {
    Alert,
    Box,
    CircularProgress,
    Grid,
    Pagination,
    Snackbar,
    Typography
} from '@mui/material';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { t } from 'i18next';
import MainCard from '../../../component/cards/MainCard';
import { EditButton } from '../../../component/buttons';
import { useNutritionTemplates } from '../../../hooks/useNutritionTemplates';
import PlanoNutricaoCard from './PlanoNutricaoCard';

function Nutrition() {
    const navigate = useNavigate();
    const location = useLocation();
    const [showCreatedMessage, setShowCreatedMessage] = useState(
        Boolean(location.state?.nutritionPlanCreated)
    );

    const {
        data: plans,
        isLoading,
        error,
        count,
        paginationModel,
        setPaginationModel
    } = useNutritionTemplates();

    const handlePageChange = (event, newPage) => {
        setPaginationModel((prev) => ({
            ...prev,
            page: newPage - 1
        }));
    };

    return (
        <MainCard title={t('nutrition.title')}>
            <Snackbar
                open={showCreatedMessage}
                autoHideDuration={5000}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                onClose={() => {
                    setShowCreatedMessage(false);
                    navigate(location.pathname, { replace: true, state: null });
                }}
            >
                <Alert severity="success" variant="filled">
                    {t('nutrition.createSuccess')}
                </Alert>
            </Snackbar>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Grid container justifyContent="flex-end" spacing={2}>
                        <Grid item>
                            <EditButton onClick={() => navigate('/nutricao/criar')}>
                                <Typography variant="subtitle2">
                                    {t('nutrition.add_plan')}
                                </Typography>
                            </EditButton>
                        </Grid>
                    </Grid>
                </Grid>

                {isLoading ? (
                    <Grid item xs={12}>
                        <Box display="flex" justifyContent="center" p={4}>
                            <CircularProgress />
                        </Box>
                    </Grid>
                ) : error ? (
                    <Grid item xs={12}>
                        <Typography color="error" align="center">
                            {t('nutrition.load_error')}
                        </Typography>
                    </Grid>
                ) : plans.length === 0 ? (
                    <Grid item xs={12}>
                        <Typography align="center">
                            {t('nutrition.none_available')}
                        </Typography>
                    </Grid>
                ) : (
                    <>
                        {plans.map((plan) => (
                            <Grid key={plan.uuid} item lg={4} md={6} sm={6} xs={12}>
                                <PlanoNutricaoCard
                                    planName={plan.name}
                                    planDesc={plan.description}
                                    pacientType={t('nutrition.title')}
                                    onClick={() => navigate(`/nutricao/${plan.uuid}`)}
                                />
                            </Grid>
                        ))}

                        <Grid item xs={12}>
                            <Box display="flex" justifyContent="center" mt={4}>
                                <Pagination
                                    count={Math.ceil(count / paginationModel.pageSize)}
                                    page={paginationModel.page + 1}
                                    onChange={handlePageChange}
                                />
                            </Box>
                        </Grid>
                    </>
                )}
            </Grid>
        </MainCard>
    );
}

export default Nutrition;
